// Per-page <title>, description and canonical for Google.
// One source of truth: the Seo component (src/components/Seo.jsx) reads this
// on every route change, and scripts/prerender.py bakes it into static HTML.
export const SITE = "https://www.fonderx.com";

export const PAGES = {
  "/": {
    title: "Currency Exchange New Westminster | FonderX",
    description:
      "Live rates on USD, EUR and 40+ currencies. Walk-in exchange at 723 12th St, New Westminster. FINTRAC registered. Open Mon–Fri 9:30 AM–6 PM.",
  },
  "/heroes": {
    title: "Frontline Heroes Exchange Rate | FonderX",
    description:
      "Paramedics, firefighters, police, 911 dispatchers, nurses and teachers get better exchange rates at FonderX. Ask in store with your work ID.",
  },
  "/about": {
    title: "About FonderX | Local Currency Exchange, New West",
    description:
      "A locally owned, FINTRAC-registered currency exchange in New Westminster, BC, serving Burnaby and Greater Vancouver.",
  },
  "/contact": {
    title: "Contact & Hours | FonderX New Westminster",
    description:
      "Visit us at Unit 2 – 723 12th St, New Westminster, BC. Call (778) 759-0400. Open Monday to Friday, 9:30 AM to 6 PM.",
  },
  "/crypto": {
    title: "Buy & Sell Crypto in New Westminster | FonderX",
    description:
      "Exchange cash for Bitcoin, USDT, ETH and more in person with a FINTRAC-registered dealer in New Westminster, BC.",
  },
  "/crypto/news": {
    title: "Crypto News Today | FonderX",
    description: "The latest cryptocurrency news, updated through the day, from FonderX Currency Exchange in New Westminster.",
  },
  "/crypto/academy": {
    title: "Crypto Academy: Learn the Basics | FonderX",
    description: "Plain-language lessons on Bitcoin, stablecoins and crypto safety from FonderX Currency Exchange.",
  },
  "/ai-predictor": {
    title: "AI Currency Outlook & Trip Planner | FonderX",
    description: "See where your currency may be heading and plan your travel cash budget with the FonderX AI tools.",
  },
  "/blog": {
    title: "Currency Exchange Tips & Guides | FonderX",
    description: "Plain guides on exchange rates, travel money and crypto from FonderX Currency Exchange in New Westminster.",
  },
  "/terms-of-service": {
    title: "Terms of Service | FonderX",
    description: "Terms of service for FonderX Currency Exchange Inc., New Westminster, BC.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | FonderX",
    description: "How FonderX Currency Exchange Inc. collects, uses and protects your personal information.",
  },
};

// Pages that must stay out of Google.
export const PRIVATE_PREFIXES = ["/auth", "/forgot-password", "/reset-password", "/dashboard", "/invoices", "/admin"];

const DEFAULT = PAGES["/"];

export function metaFor(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const noindex = PRIVATE_PREFIXES.some((p) => path === p || path.startsWith(p + "/"));
  let m = PAGES[path];
  if (!m && path.startsWith("/crypto/")) {
    const coin = decodeURIComponent(path.split("/")[2] || "");
    const name = coin.charAt(0).toUpperCase() + coin.slice(1);
    m = {
      title: `${name} Price Today & Where to Buy | FonderX`,
      description: `Live ${name} price and chart. Buy or sell ${name} in person at FonderX Currency Exchange, New Westminster, BC.`,
    };
  }
  if (!m && path.startsWith("/blog/")) {
    m = { title: "FonderX Blog", description: PAGES["/blog"].description }; // BlogPost.jsx sets the real title once loaded
  }
  const known = Boolean(m);
  return { ...(m || DEFAULT), canonical: SITE + (path === "/" ? "/" : path), noindex: noindex || !known };
}
